// eslint-disable-next-line import/prefer-default-export
export const palette = {
  waterLight: '#24A2A6',
  water: '#098B8C',
  waterDark: '#005B5E',
  waterDarkest: '#164548',

  bonsaiLight: '#5DC095',
  bonsai: '#52AD86',
  bonsaiDark: '#378763',
  bonsaiDarkest: '#306E52',

  orangeLight: '#FF704C',
  orange: '#F36442',
  orangeDark: '#BF4F33',
  orangeDarkest: '#963C26',

  gold: '#098B8C',

  neutral1: '#2F3034',
  neutral2: '#4A4B4E',
  neutral3: '#666667',
  neutral4: '#818181',
  neutral5: '#9D9C9B',
  neutral6: '#B8B7B5',
  neutral7: '#D4D2CE',
  neutral8: '#EFEDE8',
  neutral9: '#F4F3F0',
  neutral10: '#FAF9F7',
  neutral11: '#FFFFFF',
};
